/** *******************************************************************************************************************
 * Copyright (c) 2020 - Fundação CERTI
 * All rights reserved.
 ******************************************************************************************************************* */
import moment from 'moment';
// eslint-disable-next-line import/prefer-default-export
export function parseDate(value) {
  const date = moment(value, 'DD/MM/YYYY', false).toDate();
  return date;
}
